module.exports = __webpack_public_path__ + "static/media/dogsforautism.64572492.png";